import { get } from '../../helpers/fetch';
import { buildURL } from '../../helpers/urls';

export const getCrowdCountSessions = (slugDate) => {
  const params = new URLSearchParams({ slugDate });
  return get(buildURL('crowd-count', 'sessions', `?${params}`));
};

/** Scan with tile media S3-presigned (~10min). FE caches bytes by path for ~7d. */
export const getCrowdCountScan = (id) => get(buildURL('crowd-count', id));
